import React, { useState } from 'react';
export const PortfolioPage = () => {
  // Define the display names for categories (what users see)
  const categoryDisplayNames = {
    Featured: 'Featured',
    'AI and Data Infrastructure': 'AI/Data',
    'Compute Infrastructure': 'Compute',
    'Devtools, Productivity & Open-source': 'Devtools/Productivity',
    Security: 'Security',
    'Decentralized Networks & Financial Infrastructure': 'Financial Infra'
  };
  // Full category names (used for filtering)
  const categories = ['Featured', 'AI and Data Infrastructure', 'Compute Infrastructure', 'Devtools, Productivity & Open-source', 'Security', 'Decentralized Networks & Financial Infrastructure'];
  const [activeCategory, setActiveCategory] = useState('Featured');
  // Define the order for featured companies
  const featuredOrder = {
    Databricks: 1,
    Play: 2,
    Groq: 3,
    Goodnotes: 4,
    Vectara: 5,
    'Clerk Chat': 6
  };
  const companies = [{
    name: 'AirMDR',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1754429419/AirMDR_White_Large_bnnbhg.png',
    description: 'AI Managed Detection and Response Platform',
    category: 'Security',
    website: 'https://airmdr.com'
  }, {
    name: 'Airtrain',
    logo: 'https://cdn.prod.website-files.com/62e0202ed964cdb8b5ad3acd/67d326c507f26457ce2f8dc3_airwb%20large.png',
    description: 'No-code compute platform for LLM evaluation and fine-tuning',
    category: 'AI and Data Infrastructure',
    website: 'https://www.airtrain.ai/'
  }, {
    name: 'Allbridge',
    logo: 'https://uploads-ssl.webflow.com/62e0202ed964cdb8b5ad3acd/62e0202ed964cd22ebad3b83_Allbridge%20Wordmark.png',
    description: 'Bridge for crypto assets',
    category: 'Decentralized Networks & Financial Infrastructure',
    website: 'https://allbridge.io'
  }, {
    name: 'Batteries Included',
    logo: 'https://uploads-ssl.webflow.com/62e0202ed964cdb8b5ad3acd/62e0202ed964cd696cad3b85_BI%20Horizontal%20.png',
    description: 'Fully managed IaaS',
    category: 'Devtools, Productivity & Open-source',
    website: 'https://www.batteriesincl.com'
  }, {
    name: 'Citcon',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1754432033/Citcon_White_Logo_e3bp0l.png',
    description: 'Digital Wallet Payment Platform',
    category: 'Decentralized Networks & Financial Infrastructure',
    website: 'https://citcon.com'
  }, {
    name: 'Clerk Chat',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1754425497/Clerk_White_Large_hs6hcs.png',
    description: 'AI Conversational messaging platform',
    category: 'Devtools, Productivity & Open-source',
    featured: true,
    website: 'https://clerk.chat/'
  }, {
    name: 'Concierge',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1754429402/Concierge_White_Large_qpxtrx.png',
    description: 'Connected AI assistant',
    category: 'Devtools, Productivity & Open-source',
    website: 'https://askconcierge.ai/'
  }, {
    name: 'Databricks',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1754428735/Databricks_White_Large_cmbvsn.png',
    description: 'AI data analytics lakehouse',
    category: 'AI and Data Infrastructure',
    featured: true,
    website: 'https://databricks.com'
  }, {
    name: 'Goodnotes',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1754432034/Goodnotes_White_Logo_ov9hvp.png',
    description: 'AI productivity tool',
    category: 'Devtools, Productivity & Open-source',
    featured: true,
    website: 'https://www.goodnotes.com'
  }, {
    name: 'Groq',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ttK9tA93iuqza2yEHR6sMy/Groq_White_Large.png',
    description: 'AI Inference Chip',
    category: 'Compute Infrastructure',
    featured: true,
    website: 'https://groq.com/'
  }, {
    name: 'Huma',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1754432034/Huma_White_Logo_deoge5.png',
    description: 'RWA lending platform',
    category: 'Decentralized Networks & Financial Infrastructure',
    website: 'https://huma.finance'
  }, {
    name: 'HyperDX',
    logo: 'https://cdn.prod.website-files.com/62e0202ed964cdb8b5ad3acd/67d32becc09c6e597292b892_hyperdx%20large.png',
    description: 'Unified Observability Platform',
    category: 'Devtools, Productivity & Open-source',
    website: 'https://www.hyperdx.io/'
  }, {
    name: 'Irys',
    logo: 'https://cdn.prod.website-files.com/62e0202ed964cdb8b5ad3acd/653bfef4f7e569485135a7e4_Irys%20Big.png',
    description: 'Data provenance layer',
    category: 'Decentralized Networks & Financial Infrastructure',
    website: 'https://irys.xyz'
  }, {
    name: 'Lightning Labs',
    logo: 'https://uploads-ssl.webflow.com/62e0202ed964cdb8b5ad3acd/62e0202ed964cdbde3ad3bb0_Lightning%20H.png',
    description: 'Scaling and payments infrastructure',
    category: 'Compute Infrastructure',
    website: 'https://lightning.engineering'
  }, {
    name: 'Martian',
    logo: 'https://uploads-ssl.webflow.com/62e0202ed964cdb8b5ad3acd/650e2604af60364ad952a6f9_Martian%20Big.png',
    description: 'Self-custodial wallet for the Move ecosystem',
    category: 'Decentralized Networks & Financial Infrastructure',
    website: 'https://martianwallet.xyz'
  }, {
    name: 'Midas Labs',
    logo: 'https://uploads-ssl.webflow.com/62e0202ed964cdb8b5ad3acd/62e0202ed964cd5977ad3b94_Midas%20Labs%20Horizontal.png',
    description: 'Low Level Cryptography Accelerators',
    category: 'Compute Infrastructure',
    website: 'http://www.midaslabs.net/#/home'
  }, {
    name: 'Notifi',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1754426204/Notifi_White_Logo_tzwrto.png',
    description: 'Notifications and messaging infrastructure',
    category: 'Devtools, Productivity & Open-source',
    website: 'https://notifi.network'
  }, {
    name: 'Okareo',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1754425600/Okareo_White_Large_hxbglf.png',
    description: 'LLM Evaluation and Fine-Tuning',
    category: 'AI and Data Infrastructure',
    website: 'https://okareo.com/'
  }, {
    name: 'Opaque Systems',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1754428735/opaque_white_large_nos7uc.png',
    description: 'Confidential AI and Analytics Platform',
    category: 'AI and Data Infrastructure',
    website: 'https://opaque.co'
  }, {
    name: 'Openlayer',
    logo: 'https://cdn.prod.website-files.com/62e0202ed964cdb8b5ad3acd/67d1ae6fe31d4ff559880a00_Openlayer%20Large.png',
    description: 'Gen AI Evaluation and Monitoring',
    category: 'AI and Data Infrastructure',
    website: 'https://www.openlayer.com/'
  }, {
    name: 'Opsin',
    logo: 'https://cdn.prod.website-files.com/62e0202ed964cdb8b5ad3acd/67d1aad067755dc498a96a5d_Opsin%20Big.png',
    description: 'Generative AI Security orchestration layer',
    category: 'Security',
    website: 'https://www.opsinsecurity.com/'
  }, {
    name: 'Polysign',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1754426204/Polysign_White_Logo_gf5zdp.png',
    description: 'Compliant and scalable infra for digital assets',
    category: 'Decentralized Networks & Financial Infrastructure',
    website: 'https://www.polysign.io'
  }, {
    name: 'Scarf',
    logo: 'https://uploads-ssl.webflow.com/62e0202ed964cdb8b5ad3acd/62e0202ed964cd3ccbad3ba1_Scarf%20H.png',
    description: 'Analytics on Open Source Usage',
    category: 'Devtools, Productivity & Open-source',
    website: 'https://about.scarf.sh'
  }, {
    name: 'Skypilot',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1754429401/Skypilot_White_Large_dimtjc.png',
    description: 'OS framework for AI workloads',
    category: 'Compute Infrastructure',
    website: 'https://docs.skypilot.co/'
  }, {
    name: 'Social Chat',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1754426204/Social_Chat_White_Logo_ko8fwr.png',
    description: 'ML-driven e-commerce software',
    category: 'Devtools, Productivity & Open-source',
    website: 'https://socialchat.ai'
  }, {
    name: 'Solend',
    logo: 'https://uploads-ssl.webflow.com/62e0202ed964cdb8b5ad3acd/62e0202ed964cd1e46ad3ba7_Solend%20H.png',
    description: 'Decentralized lending and borrowing protocol on Solana',
    category: 'Decentralized Networks & Financial Infrastructure',
    website: 'https://solend.fi'
  }, {
    name: 'Thruline',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1754426203/Thruline_White_Logo_hm5inr.png',
    description: 'Future-Ready ERP System',
    category: 'Devtools, Productivity & Open-source',
    website: 'https://www.thruline.co/'
  }, {
    name: 'Umami',
    logo: 'https://uploads-ssl.webflow.com/62e0202ed964cdb8b5ad3acd/62e0202ed964cd29f6ad3bad_Umami%20H.png',
    description: 'Analytics focused on privacy and data ownership',
    category: 'Devtools, Productivity & Open-source',
    website: 'https://umami.is'
  }, {
    name: 'Unbound Security',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1754429389/Unbound_White_Large_d8k6sd.png',
    description: 'AI Security Gateway',
    category: 'Security',
    website: 'https://www.getunbound.ai'
  }, {
    name: 'Unify',
    logo: 'https://uploads-ssl.webflow.com/62e0202ed964cdb8b5ad3acd/664f8bfca0528e717361dc92_unifylrg.png',
    description: 'LLM Dynamic Router',
    category: 'AI and Data Infrastructure',
    website: 'https://unify.ai/'
  }, {
    name: 'Vectara',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1754936326/Vectara_White_Large_st1oba.png',
    description: 'Enterprise Gen AI platform',
    category: 'AI and Data Infrastructure',
    featured: true,
    website: 'https://vectara.com/'
  }, {
    name: 'Vectroid',
    logo: 'https://cdn.prod.website-files.com/62e0202ed964cdb8b5ad3acd/67d209abda0d973f4a4d7672_Vectroid%20Large.png',
    description: 'Vector DB for billions of vectors',
    category: 'AI and Data Infrastructure',
    website: 'https://www.vectroid.com/'
  }, {
    name: 'Zeta',
    logo: 'https://uploads-ssl.webflow.com/62e0202ed964cdb8b5ad3acd/62e0202ed964cd4989ad3bab_Zeta%20H.png',
    description: 'Options and Futures Infra',
    category: 'Decentralized Networks & Financial Infrastructure',
    website: 'https://www.zeta.markets'
  }];
  // Filter companies and sort featured companies in the specified order
  const filteredCompanies = activeCategory === 'Featured' ? companies.filter(company => company.featured).sort((a, b) => {
    // Sort based on the defined order
    return (featuredOrder[a.name] || 999) - (featuredOrder[b.name] || 999);
  }) : companies.filter(company => company.category === activeCategory);
  return <div className="w-full bg-white" data-id="element-139">
      <section className="w-full py-16 px-6 md:px-12" data-id="element-140">
        <div className="max-w-7xl mx-auto" data-id="element-141">
          <h1 className="text-4xl font-bold text-[#070707] mb-6" data-id="element-142">
            Our Portfolio
          </h1>
          <p className="text-xl text-[#070707] max-w-4xl mb-12" data-id="element-143">
            Race Capital partners with exceptional entrepreneurs building
            market-transforming companies in enterprise, infrastructure,
            fintech, and more.
          </p>
          {/* Category Filter */}
          <div className="mb-12 overflow-x-auto" data-id="element-144">
            <div className="flex space-x-4 pb-2" data-id="element-145">
              {categories.map(category => <button key={category} className={`px-4 py-2 rounded-md whitespace-nowrap ${activeCategory === category ? 'bg-red-600 text-white' : 'bg-gray-100 text-[#070707] hover:bg-gray-200'}`} onClick={() => setActiveCategory(category)} data-id="element-146">
                  {categoryDisplayNames[category]}
                </button>)}
            </div>
          </div>
          {/* Companies Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-147">
            {filteredCompanies.map((company, index) => <div key={index} className="bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-lg transition-shadow" data-id="element-148">
                <div className="p-6 h-[270px] flex items-center justify-center border-b border-gray-100" data-id="element-149">
                  <img src={company.logo} alt={`${company.name} logo`} className="max-h-[225px] max-w-[375px] object-contain" style={{
                height: company.height ? `${company.height * 1.5}px` : 'auto',
                maxHeight: '100%',
                width: 'auto'
              }} data-id="element-150" />
                </div>
                <div className="p-6" data-id="element-151">
                  <h3 className="text-xl font-semibold text-[#070707] mb-2" data-id="element-152">
                    {company.name}
                  </h3>
                  <p className="text-[#070707] mb-4" data-id="element-153">{company.description}</p>
                  <div className="flex justify-between items-center" data-id="element-154">
                    <span className="inline-block px-3 py-1 bg-gray-100 text-[#070707] text-sm rounded-full" data-id="element-155">
                      {categoryDisplayNames[company.category]}
                    </span>
                    <a href={company.website} target="_blank" rel="noopener noreferrer" className="text-red-600 hover:text-red-800 font-medium" data-id="element-156">
                      Visit →
                    </a>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </section>
    </div>;
};